import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const url = '/api/v1/categories';

export function useGetRecentWiresByCategories() {
  return useAxios({
    url: `${url}/wires/recent`,
    method: 'GET',
  });
}

export function useGetCategoryById(id) {
  const common = v => ({ url: `${url}/${v}` });
  const [state, q] = useAxios({ ...common(id), method: 'GET' }, { manual: true });
  const executeQuery = newId => q(common(newId));
  return [state, executeQuery];
}

export function getAllCategories() {
  return axios.get(url);
}
